import { EllipsedText, FlexRow, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { Cell, Grid } from 'baseui/layout-grid';
import { StyledLink } from 'baseui/link';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { canAccessMyFleetState } from '../../storage/app';
import { CurrentState } from '../../types/currentState';
import FleetCurrentDriver from '../fleet/shared/FleetCurrentDriver';

type Props = Readonly<{
  currentState: CurrentState;
  responsive?: boolean;
}>;

function CurrentStateCardBody({ currentState, responsive = false }: Props) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const labelWidth = '80px';
  const canAccessMyFleet = useRecoilValue(canAccessMyFleetState);

  return (
    <Block
      className={css({
        padding: theme.sizing.scale600,
        height: responsive ? '72px' : '48px',
      })}
    >
      <FlexRow>
        <Grid
          gridColumns={12}
          gridGaps={[4]}
          gridGutters={[16]}
          gridMargins={[0]}
        >
          <Cell span={[12]}>
            <LabeledData
              label={'Dirección:'}
              labelWidth={labelWidth}
              content={
                <StyledLink
                  href={`https://maps.google.com/?q=${currentState.position_latitude},${currentState.position_longitude}`}
                  target="_blank"
                  style={{ color: theme.colors.contentSecondary, ...theme.typography.ParagraphSmall }}
                >
                  <EllipsedText
                    inline
                    breakAll
                  >
                    {currentState.geoReference}
                  </EllipsedText>
                </StyledLink>
              }
            />
          </Cell>
          <Cell span={responsive ? 12 : 4}>
            <LabeledData
              label={'Velocidad:'}
              content={`${currentState.position_speed} Km/h`}
              labelWidth={labelWidth}
            />
          </Cell>
          <Cell span={responsive ? 12 : 8}>
            <LabeledData
              label={'Fecha:'}
              content={`${formatDateFromTs(+currentState.timestamp)}`}
              labelWidth={responsive ? labelWidth : '50px'}
            />
          </Cell>
        </Grid>
        {canAccessMyFleet && <FleetCurrentDriver driver={currentState.asset.gorilaDriver} />}
      </FlexRow>
    </Block>
  );
}

export default memo(CurrentStateCardBody);
